import { createContext, useCallback, useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const ConfirmContext = createContext(null);

// Substitui `window.confirm` (pedido do Jason, 28/09/2026: "dá pra trocar por modal, algo mais
// moderno?") por um modal do próprio painel — segue o mesmo espírito da regra de 2026-09-19 sobre
// Toast: nada de diálogo nativo do navegador, tudo com a cara do sistema.
//
// Uso: const confirmar = useConfirm(); if (!(await confirmar('Excluir este item?'))) return;
// Aceita string direto, ou um objeto { titulo, mensagem, textoConfirmar, textoCancelar, variante }
// pra casos que precisam de mais contexto (variante: 'perigo' deixa o botão de confirmar vermelho).
export function ConfirmProvider({ children }) {
  const [estado, setEstado] = useState(null); // { opcoes, resolver } | null

  const confirmar = useCallback((opcoesOuMensagem) => {
    const opcoes = typeof opcoesOuMensagem === 'string' ? { mensagem: opcoesOuMensagem } : opcoesOuMensagem;
    return new Promise((resolver) => setEstado({ opcoes, resolver }));
  }, []);

  function decidir(valor) {
    estado?.resolver(valor);
    setEstado(null);
  }

  return (
    <ConfirmContext.Provider value={confirmar}>
      {children}
      {estado && <ConfirmModal opcoes={estado.opcoes} aoDecidir={decidir} />}
    </ConfirmContext.Provider>
  );
}

function ConfirmModal({ opcoes, aoDecidir }) {
  const perigo = opcoes.variante === 'perigo';
  return (
    <Modal show centered onHide={() => aoDecidir(false)}>
      {opcoes.titulo && (
        <Modal.Header closeButton style={{ backgroundColor: 'var(--cor-primaria)', color: '#fff', borderBottom: 0 }}>
          <Modal.Title className="h6 mb-0">{opcoes.titulo}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{opcoes.mensagem}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => aoDecidir(false)}>
          {opcoes.textoCancelar || 'Cancelar'}
        </Button>
        <Button variant={perigo ? 'danger' : 'primary'} className={perigo ? '' : 'botao-salvar'} onClick={() => aoDecidir(true)}>
          {opcoes.textoConfirmar || 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export function useConfirm() {
  return useContext(ConfirmContext);
}
